<template>
  <div
    v-if="leader"
    class="leaderDetails mainCard"
  >
    <el-page-header
      title="Go Back"
      :content="null"
      @back="$router.push({name: 'myLeaders'}).catch(() => {})"
    />

    <LeaderSimple
      v-loading="loading"
      :leader.sync="leader"
      :is-details-view="true"
      :role="user.user.role_type"
      :session.sync="session"
      :meetings="meetings"
      @duration-changed="getMeetingStatus"
    />

    <!--<el-row
      v-if="['desktop', 'laptop'].includes($mq)"
      :gutter="5"
      type="flex"
    >
      <el-col :span="6">
        <Counter
          v-loading="loading"
          :value="leader.stakeholder_count"
          label="Coworkers"
        />
      </el-col>
      <el-col :span="6">
        <Meeting
          v-loading="loading"
          :meeting="leader.next_meeting"
        />
      </el-col>
      <el-col :span="12">
        <Tasks
          v-loading="loading"
          :leader="leader"
          :filtered="true"
          :tasks.sync="leader.leader_tasks"
          :task-from="'leader'"
          :session.sync="session"
          :meetings="meetings"
          title="Leader's Tasks"
        />
      </el-col>
    </el-row>-->

    <el-row>
      <el-col :span="24">
        <SessionAttendance
          v-loading="loading"
          :leader="leader"
          :meetings="meetings"
          @attendanceChanged="getMeetingStatus"
        />
      </el-col>
    </el-row>

    <el-row
      v-if="['desktop', 'laptop'].includes($mq)"
      :gutter="5"
      type="flex"
    >
      <el-col :span="12">
        <LGA
          v-if="leader"
          v-loading="loading"
          :leader.sync="leader"
          :lga.sync="leader.lga"
        />
      </el-col>
      <el-col :span="12">
        <GLA
          v-loading="loading"
          :leader="leader"
        />
      </el-col>
    </el-row>
    <div v-else>
      <LGA
        v-loading="loading"
        style="margin-bottom: 15px;"
        :leader="leader"
      />
      <GLA
        v-loading="loading"
        style="margin-bottom: 15px;"
        :leader="leader"
      />
    </div>

    <el-row
      v-if="['desktop', 'laptop'].includes($mq) && user.user.role_type === 'coach'"
      :gutter="5"
      type="flex"
      class="roundedRow"
    >
      <el-col :span="12">
        <FeedForwards :leader-uuid="leader.uuid" />
      </el-col>
      <el-col :span="12">
        <SessionDetails
          :leader-uuid="leader.uuid"
          :leader="leader"
          :current-session="session ? session : 0"
          :meetings="meetings"
        />
      </el-col>
    </el-row>
    <el-row
      v-if="['mobile', 'tablet'].includes($mq)"
      :gutter="5"
      type="flex"
    >
      <el-col :span="24">
        <Tasks
          :leader="leader"
          :tasks.sync="leader.coach_tasks"
          :meetings="meetings"
          :filtered="true"
          :session.sync="session"
          :is-details-view="true"
          title="My Tasks"
        />
      </el-col>
    </el-row>

    <el-row
      v-if="['desktop', 'laptop'].includes($mq)"
      :gutter="5"
      type="flex"
    >
      <el-col :span="12">
        <ActionPlan
          :leader-uuid="leader.uuid"
          :session="session"
        />
      </el-col>
      <el-col :span="12">
        <Pulse
          :leader-uuid="leader.uuid"
          :session="session"
        />
      </el-col>
    </el-row>
    <el-row
      v-if="['mobile', 'tablet'].includes($mq)"
      :gutter="5"
      type="flex"
    >
      <el-col :span="24">
        <ActionPlan
          :leader-uuid="leader.uuid"
          :session="session"
        />
      </el-col>
    </el-row>

    <el-row
      v-if="['mobile', 'tablet'].includes($mq)"
      :gutter="5"
      type="flex"
    >
      <el-col :span="24">
        <Pulse
          :leader-uuid="leader.uuid"
          :session="session"
        />
      </el-col>
    </el-row>

    <el-row>
      <CoworkersTable
        :coworkers="leader.stakeholders"
        :loading="loading"
      />
    </el-row>

    <el-row v-if="['mobile', 'tablet'].includes($mq)">
      <el-col :span="24">
        <FeedForwards :leader-uuid="leader.uuid" />
      </el-col>
    </el-row>

    <el-row :gutter="5">
      <el-col :span="12">
        <CvcReview
          v-if="leader && leader.curr_engagement_uuid"
          :engagement="leader.curr_engagement_uuid"
        />
      </el-col>
    </el-row>

    <GLAModal
      :show.sync="showGLAModal"
      :leader="leader"
    />

    <SowModal
      :show.sync="showSowModal"
      :leader.sync="leader"
    />

    <LeaderEngagementPaused
      :show="showEngagementPausedModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import LeaderSimple from './LeaderSimple.vue';
// import Counter from './widgets/Counter.vue';
import Tasks from './widgets/Tasks.vue';
import ActionPlan from './widgets/ActionPlan.vue';
import Pulse from './widgets/Pulse.vue';
import FeedForwards from './widgets/FeedForwards.vue';
import SessionDetails from './widgets/SessionDetails.vue';
// import Meeting from './widgets/Meeting.vue';
import SessionAttendance from './widgets/SessionAttendance.vue';
import CvcReview from './widgets/CvcReview.vue';
import GLAModal from './widgets/GLAModal.vue';
import CoworkersTable from './widgets/CoworkersTable.vue';
import LGA from './widgets/LGA.vue';
import GLA from './widgets/GLA.vue';
import SowModal from './widgets/SowModal.vue';
import LeaderEngagementPaused from './widgets/LeaderEngagementPaused.vue';

export default {
  name: 'LeaderDetails',

  components: {
    LeaderSimple,
    // Counter,
    Tasks,
    ActionPlan,
    Pulse,
    FeedForwards,
    SessionDetails,
    // Meeting,
    SessionAttendance,
    CvcReview,
    GLAModal,
    CoworkersTable,
    LGA,
    GLA,
    SowModal,
    LeaderEngagementPaused,
  },

  props: {
    id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      leader: null,
      loading: false,
      showGLAModal: false,
      showSowModal: false,
      showEngagementPausedModal: false,
      meetings: {},
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    session() {
      const tmp = this.leader.session_id.split('_');
      let result = 0;
      if (tmp.length && /^[0-9]*$/.test(tmp[(tmp.length - 1)])) {
        result = parseInt(tmp[(tmp.length - 1)], 10);
      }
      return result;
    },

    session1MeetingStatus() {
      if (!this.meetings || this.meetings.meeting_status.length < 1) return null;

      const session1Meeting = this.meetings.meeting_status.find(
        (el) => el.session_id === 'session_1',
      );

      if (session1Meeting) return session1Meeting.status;

      return null;
    },
  },

  watch: {
    $route() {
      this.init();
    },
  },

  async created() {
    this.init();

    // If get changed emit, refresh session list
    this.$EventBus.$on('attendance_changed', () => {
      this.getUserStatus();
    });
  },

  mounted() {
    this.$EventBus.$on('alert_changed', (data) => {
      if (data.type === 'Attendance') {
        if (!this.leader.gla_uuid) {
          this.showGLAModal = true;
        }
      }
    });
  },

  methods: {
    async init() {
      await this.getLeaderDetails();
      await this.getMeetingStatus();

      if (!this.leader.gla_uuid && this.session >= 1 && this.session1MeetingStatus === 'completed') {
        this.showGLAModal = true;
      }

      if (this.leader.curr_engagement_status === 'exception') {
        this.showEngagementPausedModal = true;
      }
    },

    async getLeaderDetails() {
      try {
        let response = {};
        this.loading = true;
        response = await api.getCoachLeaderDetails(this.$route.params.id);
        this.leader = response.data;
        if (!this.leader.is_sow_confirmed) {
          this.showSowModal = true;
        }
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
        if (err.response && err.response.status === 404) {
          this.$router.push({ name: '404' });
        }
      } finally {
        this.loading = false;
      }
    },

    async getMeetingStatus() {
      try {
        const response = await api.getCoachLeaderMeetingStatus(this.leader.uuid);
        this.meetings = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
        console.log(err);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.leaderDetails {
  .el-row {
    .el-col {
      margin-bottom: 15px;

      .el-card {
        border-radius: 0;
        height: 100%;
      }

      &:first-child {
        .el-card {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }
      }

      &:last-child {
        .el-card {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }
      }
    }

    &.roundedRow {
      .el-col {
        .el-card {
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
